// removed by extract-text-webpack-plugin
module.exports = {"econom":"_3j7FiIB-WNR_Jdd2_nao3U","tg":"_2XxcJZfM7AQ5f5kIFe7Y6h","tgF6ar":"_1dVyGH-b_roQL0yRHweHoJ","tgT3d6":"_2ugpaUtvPuaWRYwp_34k1N","tgCxkv":"_3pSYCIgqTJ10WWIVWSfCWr","kpd":"_1UgmF-8s6MVDHRZLNHXFEq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/Economentry/style.css
// module id = 335
// module chunks = 0